import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import {
  Code,
  Laptop,
  Devices,
  Accessibility,
  Web,
} from '@mui/icons-material';

const techStack = [
  {
    title: 'Built with React',
    description:
      'We use React for a seamless and fast user interface, providing a responsive experience.',
    icon: <Code sx={{ fontSize: 50, color: '#61DAFB' }} />,
  },
  {
    title: 'Powered by Node.js',
    description:
      'Our backend is powered by Node.js, ensuring fast and scalable server-side performance.',
    icon: <Laptop sx={{ fontSize: 50, color: '#68A063' }} />,
  },
  {
    title: 'User-Friendly Interface',
    description:
      'Designed with the user in mind, our platform offers an intuitive and seamless experience.',
    icon: <Devices sx={{ fontSize: 50, color: '#FF9800' }} />,
  },
  {
    title: 'Accessible to All',
    description:
      'We prioritize accessibility, ensuring everyone can easily interact with the platform.',
    icon: <Accessibility sx={{ fontSize: 50, color: '#F48FB1' }} />,
  },
  {
    title: 'Built with Modern Web Tech',
    description:
      'Our platform is designed using the latest web technologies for speed and scalability.',
    icon: <Web sx={{ fontSize: 50, color: '#7C4DFF' }} />,
  },
];

const BuiltWithTech = () => {
  return (
    <Box
      sx={{
        background: '#000000',
        color: 'white',
        py: 8,
        px: 3,
        textAlign: 'center',
        borderRadius: '20px',
        boxShadow: '0px 10px 25px rgba(0,0,0,0.4)',
        mt: 10,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 'bold',
          mb: 2,
          textTransform: 'uppercase',
          letterSpacing: 2,
          fontSize: { xs: '1.8rem', md: '2.5rem' },
        }}
      >
        Built with Latest Technologies
      </Typography>

      <Typography
        variant="subtitle1"
        sx={{
          color: '#cccccc',
          maxWidth: 600,
          mx: 'auto',
          mb: 6,
          fontSize: '1rem',
        }}
      >
        Our platform combines the latest in technology with an intuitive, user-friendly design.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {techStack.map((tech, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              sx={{
                backdropFilter: 'blur(10px)',
                background: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '16px',
                padding: '30px 20px',
                border: '1px solid rgba(255,255,255,0.1)',
                transition: 'all 0.35s ease',
                textAlign: 'center',
                boxShadow: '0px 6px 18px rgba(0,0,0,0.3)',
                '&:hover': {
                  transform: 'scale(1.03)',
                  boxShadow: '0px 10px 30px rgba(0,0,0,0.6)',
                  borderColor: '#1E90FF',
                },
              }}
            >
              <Box
                sx={{
                  width: 70,
                  height: 70,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255,255,255,0.08)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px auto',
                }}
              >
                {tech.icon}
              </Box>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                  mb: 1,
                  color: '#ffffff',
                }}
              >
                {tech.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: '0.9rem',
                  color: '#cfcfcf',
                  maxWidth: 300,
                  mx: 'auto',
                }}
              >
                {tech.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BuiltWithTech;
